/**
 * Returns a filtered list of data types based on the sensor type id.
 * @param {number} sensorTypeId
 * @param {string[]} dataTypes
 * @returns {string[]}
 */
function getDefaultVisibleDataTypes(units, dataTypes = []) {
  // Loop through all units and their connected sensors and check sensor types.
  let visibleDataTypes = [];

  for (const Unit of units) {
    for (const UnitSensor of Unit.UnitSensors || []) {
      const sensor = UnitSensor.Sensor;
      if (!sensor) continue;
      const sensorType = sensor.SensorType;
      if (!sensorType) continue;

      switch (sensorType) {
        case 'PowerMoniMain':
          visibleDataTypes.push('power');
          break;
        case 'PowerMoniSpot':
          if (sensor.CalibrationType !== 'Level1') {
            visibleDataTypes.push('power');
          } else {
            visibleDataTypes.push('uncalibrated-current');
          }
          break;
        case 'HeatMoniSpot':
          visibleDataTypes.push('temperature');
          break;
        case 'TempMoniSpot':
          visibleDataTypes.push('temperature');
          break;

        case 'FlowMoniVolume':
          visibleDataTypes.push('flow-speed');
          visibleDataTypes.push('accumulated-flow');
          visibleDataTypes.push('temperature');
          break;

        case 'TempMoniDC':
          visibleDataTypes.push('temperature');
          break;
        case 'FlowMoniEnergy':
          visibleDataTypes.push('accumulated-flow');
          visibleDataTypes.push('temperature');
          visibleDataTypes.push('indicative-consumption');
          break;
        case 'GateWaySensor':
          visibleDataTypes.push('temperature');
          visibleDataTypes.push('humidity');
          visibleDataTypes.push('co2-consumption');
          break;
        default:
          visibleDataTypes = dataTypes;
      }
    }
  }
  return Array.from(new Set(visibleDataTypes));
}

export default getDefaultVisibleDataTypes;
